export default __webpack_public_path__ + "static/media/arknote.8d070298.png";